var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Card, CardExpandableContent, CardHeader, CardTitle, Divider, Flex, FlexItem, } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
export const MultiContentCardDividerVariant = {
    left: 'left',
    right: 'right'
};
export const isCardWithProps = (card) => !!card && !React.isValidElement(card);
const useStyles = createUseStyles({
    cardTitle: {
        fontSize: 'var(--pf-t--global--font--size--heading--h3)',
    }
});
const MultiContentCard = (_a) => {
    var { cards = [], isToggleRightAligned = false, actions, toggleText, toggleContent, withDividers = false, isExpandable = false, defaultExpanded = true, ouiaId = 'MultiContentCard' } = _a, props = __rest(_a, ["cards", "isToggleRightAligned", "actions", "toggleText", "toggleContent", "withDividers", "isExpandable", "defaultExpanded", "ouiaId"]);
    const [isExpanded, setIsExpanded] = React.useState(defaultExpanded);
    const classes = useStyles();
    const onExpand = () => {
        setIsExpanded(!isExpanded);
    };
    const renderCards = (cards, withDividers) => (React.createElement(Flex, { alignSelf: { default: 'alignSelfStretch' }, alignItems: { default: 'alignItemsStretch' } }, cards.map((card, index) => (React.createElement(React.Fragment, { key: `card-${index}` },
        index > 0 && isCardWithProps(card) && card.dividerVariant === MultiContentCardDividerVariant.left && (React.createElement(Divider, { orientation: { md: 'vertical' }, inset: { default: 'inset3xl' } })),
        React.createElement(FlexItem, { key: `card-${index}`, flex: { default: 'flex_1' }, "data-ouia-component-id": `${ouiaId}-content-${index}` }, isCardWithProps(card) ? card.content : card),
        (index + 1 < cards.length && (withDividers || isCardWithProps(card) && card.dividerVariant === MultiContentCardDividerVariant.right)) && (React.createElement(Divider, { orientation: { md: 'vertical' }, inset: { default: 'inset3xl' } })))))));
    return (React.createElement(Card, Object.assign({ isExpanded: isExpanded, ouiaId: ouiaId }, props),
        isExpandable && (React.createElement(CardHeader, { "data-ouia-component-id": `${ouiaId}-header`, onExpand: onExpand, isToggleRightAligned: isToggleRightAligned, toggleButtonProps: {
                'aria-label': 'Details',
                'aria-expanded': isExpanded
            }, actions: { actions } }, toggleText ? React.createElement(CardTitle, { component: "h3", className: classes.cardTitle, "data-ouia-component-id": `${ouiaId}-title` }, toggleText) : toggleContent)),
        isExpandable ? React.createElement(CardExpandableContent, { "data-ouia-component-id": `${ouiaId}-expandable-content` }, renderCards(cards, withDividers)) : renderCards(cards, withDividers)));
};
export default MultiContentCard;
